import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

// Connects to data-controller="overlays--drawer"
export default class extends Controller {
  static targets = ["container", "backdrop", "drawer"];

  connect() {
    this.containerTarget.classList.remove("hidden");
    enter(this.backdropTarget);
    enter(this.drawerTarget);
  }

  hide() {
    Promise.all([leave(this.backdropTarget), leave(this.drawerTarget)]).then(
      () => {
        this.containerTarget.classList.add("hidden");
        this.containerTarget.remove();
      },
    );
  }
}
